const Helper={
  sort_colorways_by_shop:(colorways)=>{
    let result=[];
    if(colorways){
      let available_shops=colorways.reduce((acc,current)=>{
        if(acc.indexOf(current.shop_id)===-1){
          return([...acc,current.shop_id])
        }
        else{
          return acc
        }
      },[]);

      available_shops.forEach((shop_id)=>{
        let colorways_of_this_shop=colorways.filter((colorway)=>colorway.shop_id===shop_id);
        let tempShop={
          shop_id:shop_id,
          banner:colorways_of_this_shop[0].banner2,
          colorways:colorways_of_this_shop,
        }
        result.push(tempShop);
      })
    }

    return(result);
  },

  insert_link:(link,u1,tracking_id)=>{
    return(link+"&"+tracking_id+"="+u1);
     /*
     let linkURL=new URL(link);
     linkURL.searchParams.append(tracking_id,u1);
     return linkURL.toString();*/
  },

  add_options_img:(url,width,format="png")=>{
    try{
      let file_without_format=url.substr(0,url.lastIndexOf("."));
      return(__cdn__ + file_without_format+"_"+width+"x"+width+"."+format);
    }
    catch(error){
      return(url)
    }
  },

  create_source_set:(image,maxWidth=5000,format="png")=>{
    let widths=[143,286,585,1170,2048];
    let returnValue="";

    if(image.thumbnails==="1" && image.hasOwnProperty("master")){
      widths.forEach((width)=>{
        if(width<=maxWidth){
          returnValue+=(Helper.add_options_img(image.master,width,format) +" " + width + "w,")
        }
      })
      return(returnValue);

    }
    else{
      return(image.url +" 1020w")
    }
  },


}
export default Helper
